var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.405,
    height: 32.957,
    viewBox: "0 0 27.405 32.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24293",
    "data-name": "Rectangle 24293",
    width: 27.405,
    height: 32.957,
    fill: "#a1a3ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48583",
    "data-name": "Group 48583",
    transform: "translate(-2.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48582",
    "data-name": "Group 48582",
    transform: "translate(2.272)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94743",
    "data-name": "Path 94743",
    d: "M.009,53.1c0-3.985.019-7.971-.009-11.956a2.736,2.736,0,0,1,2.735-2.815c.506,0,1.012.011,1.517,0,.207-.006.26.054.263.259A7.41,7.41,0,0,0,4.572,40.1a2.268,2.268,0,0,0,4.493-.4c.007-.349.022-.7,0-1.047-.013-.248.06-.334.317-.326.553.018,1.108,0,1.661,0,2.324,0,4.647,0,6.971-.01.306,0,.384.084.372.381a5.622,5.622,0,0,0,.036,1.3,2.321,2.321,0,0,0,2.254,1.949,2.366,2.366,0,0,0,2.182-1.829,5.932,5.932,0,0,0,.069-1.473c0-.221.036-.322.291-.308a10.8,10.8,0,0,0,1.191,0A2.8,2.8,0,0,1,27.4,41.294c-.02,2.853,0,5.707,0,8.56,0,4.985-.011,9.969,0,14.954A3.427,3.427,0,0,1,25.451,68.2a2.78,2.78,0,0,1-1.246.306q-10.53,0-21.059,0A3.22,3.22,0,0,1,.032,65.493C-.013,62.917.008,60.34,0,57.764q0-2.33,0-4.659Zm13.685-9.239v.005q-5.743,0-11.485,0c-.533,0-.661.116-.661.646q0,10.239,0,20.478a1.859,1.859,0,0,0,.54,1.438,2.039,2.039,0,0,0,1.461.607c6.766-.014,13.532-.005,20.3-.008a1.939,1.939,0,0,0,2.03-2.043q0-8.686-.008-17.371c0-1.047,0-2.095-.013-3.142-.007-.476-.164-.61-.6-.61H13.694",
    transform: "translate(0 -35.546)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94744",
    "data-name": "Path 94744",
    d: "M75.712,2.781c0,.433.021.867,0,1.3a1.4,1.4,0,0,1-1.393,1.446,1.372,1.372,0,0,1-1.486-1.263,11.932,11.932,0,0,1,.027-3.123,1.434,1.434,0,0,1,2.828.13c.046.5.009,1.008.009,1.512h.019",
    transform: "translate(-67.478 0)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94745",
    "data-name": "Path 94745",
    d: "M267.813,2.816c0,.432.007.865,0,1.3a1.478,1.478,0,0,1-1.457,1.476,1.459,1.459,0,0,1-1.421-1.4c-.033-.936-.035-1.875,0-2.81A1.4,1.4,0,0,1,266.4.048a1.431,1.431,0,0,1,1.408,1.4c.021.455,0,.913,0,1.369h0",
    transform: "translate(-245.746 -0.044)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94746",
    "data-name": "Path 94746",
    d: "M82.632,248.194a2.759,2.759,0,0,1,.387,1.61c-.014,1.324-.006,2.648-.011,3.972a1.173,1.173,0,0,1-1.255,1.261q-.56,0-1.119,0a1.017,1.017,0,0,1-1.1-1.1c-.009-.566-.009-.565-.58-.565-2.949,0-5.9,0-8.847-.006-.269,0-.361.058-.33.332a1.138,1.138,0,0,1-1.348,1.343c-.347-.024-.7,0-1.047-.006a1.076,1.076,0,0,1-1.135-1.1c-.017-1.528-.007-3.057,0-4.586a1.658,1.658,0,0,1,.234-.859c.131-.213.164-.289-.146-.35a1.013,1.013,0,0,1-.835-1.337.891.891,0,0,1,.881-.659c.385,0,.772-.016,1.155.01a.727.727,0,0,0,.79-.526c.226-.54.464-1.076.727-1.6a2.435,2.435,0,0,1,2.312-1.424c2.022-.01,4.045.039,6.066-.015a2.8,2.8,0,0,1,3.025,2.029c.155.363.306.728.459,1.092a.623.623,0,0,0,.669.433c.324-.02.65,0,.975,0a1.039,1.039,0,0,1,1.151.977c.02.575-.389,1-1.083,1.069m-2.682-1.136c-.394-.842-.736-1.617-1.12-2.371a1.141,1.141,0,0,0-1.115-.64c-2.034.017-4.068.022-6.1,0a1.3,1.3,0,0,0-1.322.844c-.285.632-.562,1.267-.866,1.889-.128.262-.053.281.193.281q4.765-.008,9.531,0h.8m.061,4.209a3.964,3.964,0,0,0,.836-.047.866.866,0,0,0,.655-.683.825.825,0,0,0-.273-.872,2.606,2.606,0,0,0-2.22-.073.928.928,0,0,0-.43,1.082c.135.438.375.59.94.594h.491m-10.765.008v-.009c.192,0,.385.012.576,0a.87.87,0,0,0,.87-1.029,1.231,1.231,0,0,0-1.03-.83,9.011,9.011,0,0,0-1.044,0,.9.9,0,0,0-.859.854.919.919,0,0,0,.769.978,6,6,0,0,0,.717.038",
    transform: "translate(-60.718 -225.045)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94747",
    "data-name": "Path 94747",
    d: "M197.938,152.57h4.187a.691.691,0,0,1,.768.7.7.7,0,0,1-.774.75q-4.205.005-8.41,0a.671.671,0,0,1-.734-.739.648.648,0,0,1,.741-.723q2.111,0,4.223,0v.006",
    transform: "translate(-179.015 -141.528)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94748",
    "data-name": "Path 94748",
    d: "M197.951,197.274q-2.095,0-4.189,0a.725.725,0,1,1,.014-1.449h8.378a.678.678,0,0,1,.755.566.755.755,0,0,1-.418.835.858.858,0,0,1-.388.047q-2.076,0-4.153,0",
    transform: "translate(-179.042 -181.66)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94749",
    "data-name": "Path 94749",
    d: "M52.423,152.574h3.248c.567,0,.849.244.846.738,0,.471-.291.721-.832.721H49.045a.685.685,0,0,1-.781-.658c-.035-.527.219-.8.766-.8,1.131,0,2.261,0,3.392,0v0",
    transform: "translate(-44.77 -141.532)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94750",
    "data-name": "Path 94750",
    d: "M52.323,197.284c-1.107,0-2.213,0-3.32,0a.677.677,0,0,1-.771-.736c0-.473.267-.714.789-.713l6.712,0a.676.676,0,0,1,.762.709.684.684,0,0,1-.744.734c-1.143.005-2.286,0-3.428,0Z",
    transform: "translate(-44.743 -181.668)",
    fill: "#a1a3ef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingHours);
export default __webpack_public_path__ + "static/media/TrainingHours.75b4314793bffa2f248248f7eec4d20f.svg";
export { ForwardRef as ReactComponent };